import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Card } from 'react-bootstrap';
import MainNavbar from '../components/MainNavbar';
import MainFooter from '../components/MainFooter';
import api from '../lib/api';
import useSiteBootstrap from '../hooks/useSiteBootstrap';

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const site = useSiteBootstrap();

  useEffect(() => {
    api.get(`/public/pages/${slug}/`)
      .then((res) => setPage(res.data))
      .catch(() => setPage({ title: '', content: '', seo_title: '', seo_description: '' }));
  }, [slug]);

  return (
    <>
      <Helmet>
        {page?.seo_title || page?.title ? <title>{page?.seo_title || page?.title}</title> : null}
        {page?.seo_description ? <meta name="description" content={page?.seo_description} /> : null}
        {site?.settings?.seo_keywords ? <meta name="keywords" content={site?.settings?.seo_keywords} /> : null}
        <link rel="icon" href={site?.settings?.favicon_url || '/favicon.ico'} />
      </Helmet>
      <MainNavbar />
      <Container className="py-5">
        <Card className="p-4 shadow-sm">
          <h2>{page?.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: page?.content || '' }} />
        </Card>
      </Container>
      <MainFooter />
    </>
  );
}
